import script from "./ProjectStrategy.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectStrategy.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectStrategy.vue?vue&type=style&index=0&id=f193932a&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f193932a"]])

export default __exports__